import { render, staticRenderFns } from "./PaymentRadios.vue?vue&type=template&id=3492b91a&"
import script from "./PaymentRadios.vue?vue&type=script&lang=js&"
export * from "./PaymentRadios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports